// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad6cf0ac","239":"c998a50e","732":"b02468bd"}[chunkId] + ".chunk.js";
};